function stringLiterals<T extends string>(...args: T[]): readonly T[] {
    return Object.freeze(args);
}

export const INDUSTRIES = Object.freeze([
    '農業、林業、漁業',
    '鉱業、採石業、砂利採取業',
    '建設業',
    '食料品、飲料・たばこ・飼料製造業',
    '繊維工業',
    '木材・木製品、パルプ・紙・紙加工品 製造業',
    '化学工業',
    '石油製品・石炭製品製造業',
    '窯業・土石製品製造業',
    '鉄鋼業',
    '非鉄金属製造業',
    '金属製品製造業',
    'はん用機械器具製造業',
    '生産用機械器具製造業',
    '業務用機械器具製造業',
    '電気機械器具製造業',
    '情報通信機械器具、電子部品・デバ イス・電子回路製造業',
    '輸送機械器具製造業',
    'その他の製造業',
    '電気・ガス・熱供給・水道業',
    '情報通信業',
    '運輸業',
    '卸売業、小売業',
    '金融業、保険業',
    '不動産業',
    '物品賃貸業',
    '宿泊業、飲食サービス業',
    '教育、学習支援、医療、福祉、複合 サービス業',
    'サービス業',
]);

export const SCALES = Object.freeze([
    '従業員5人以下',
    '従業員20人以下',
    '従業員50人以下',
    '従業員100人以下',
    '従業員300人以下',
    '従業員1000人以下',
    '従業員1001人以上'
]);

export const LOCATIONS = Object.freeze([
    '北海道',
    '青森県',
    '岩手県',
    '宮城県',
    '秋田県',
    '山形県',
    '福島県',
    '茨城県',
    '栃木県',
    '群馬県',
    '埼玉県',
    '千葉県',
    '東京都',
    '神奈川県',
    '新潟県',
    '富山県',
    '石川県',
    '福井県',
    '山梨県',
    '長野県',
    '岐阜県',
    '静岡県',
    '愛知県',
    '三重県',
    '滋賀県',
    '京都府',
    '大阪府',
    '兵庫県',
    '奈良県',
    '和歌山県',
    '鳥取県',
    '島根県',
    '岡山県',
    '広島県',
    '山口県',
    '徳島県',
    '香川県',
    '愛媛県',
    '高知県',
    '福岡県',
    '佐賀県',
    '長崎県',
    '熊本県',
    '大分県',
    '宮崎県',
    '鹿児島県',
    '沖縄県'
]);

export const ERROR_LEVELS = Object.freeze({
    error: 'エラー',
    warn: '警告',
    info: '情報',
    good: '良好',
    none: ''
});

export const SERVICE_TYPES = Object.freeze({
    produce: '提供',
    consume: '利用',
    common: '共通'
});

/**
 * 取引契約のサービス区分
 */
export const TRADE_CONTRACT_SERVICE_TYPES = Object.freeze({
    producer: '提供',
    consumer: '利用'
});

/**
 * 契約プロファイルの契約事項のヒント
 */
export const CONTRACT_PROFILE_PARAMETER_HINTS = Object.freeze([{
    title: 'use',
    hint: '内容欄に入力したイベント実装 ID のモニタイベントが発火した場合は、サービス記録の通知 API により"利用"を報告しなければならないという制約を与えます。',
}, {
    title: 'delete',
    hint: '削除に関わる制約を与えます。',
    contents: [{
        value: 'required',
        hint: '削除リクエストがあった場合に取引データを削除しなければならないという制約を与えます。',
    }, {
        value: 'reporting',
        hint: '取引データを削除した場合に、サービス記録の通知 API により"削除"を報告しなければならないという制約を与えます。',
    }]
}, {
    title: 'revise',
    hint: '取引データを改変した場合の制約を与えます。',
    contents: [{
        value: 'prohibited',
        hint: '取引データの改変の禁止という制約を与えます。',
    }, {
        value: 'reporting',
        hint: '取引データを改変した場合に、報告しなければならないという制約を与えます。',
    }]
}, {
    title: 'store',
    hint: '取引データを保存した場合の制約を与えます',
    contents: [{
        value: 'prohibited',
        hint: '取引データの保存の禁止という制約を与えます。',
    }, {
        value: 'reporting',
        hint: '取引データを保存した場合に、報告しなければならないという制約を与えます。',
    }]
}, {
    title: 'duplicate',
    hint: '取引データを複製した場合の制約を与えます。',
    contents: [{
        value: 'prohibited',
        hint: '取引データの複製の禁止という制約を与えます。',
    }, {
        value: 'reporting',
        hint: '取引データを複製した場合に、報告しなければならないという制約を与えます。',
    }]
}]);

/**
 * 取引契約のステータス
 */
export const TRADE_CONTRACT_STATUSES = Object.freeze({
    preparing: "編集中",
    suspended: "取引終了",
    trading: "取引中",
    rejected: "不成約",
    revising: "修正中",
    applying: "申込中",
    requesting: "申請中",
    private: "募集停止",
    public: "募集中"
});

export const SERVICE_IMPLEMENTATION_STATUSES = Object.freeze({
    ready:     '正常',
    halt:      '停止',
    failure:   '故障',
    exception: '例外'
});

export const DATA_IMPLEMENTATION_STATUSES = Object.freeze({
    valid:     '正常',
    invalid:   '無効',
    exception: '例外'
});

/**
 * 契約メッセージの要求区分
 */
export const CONTRACT_MESSAGE_REQUEST_TYPES = Object.freeze({
    request: '申請',
    publish: '募集',
    subscribe: '申込',
    accept: '承認',
    revise: '差戻',
    cancel: '取消',
    reject: '拒否',
    suspend: '停止',
    resume: '再開',
    inquire: '照会',
});

/**
 * 辞書種別毎の名称
 */
export const DICTIONARY_TYPE_NAMES = Object.freeze({
    common: '共通辞書',
    local: '個別辞書',
    external: '外部辞書',
});

/**
 * 辞書種別毎の色
 */
export const DICTIONARY_TYPE_COLORS = Object.freeze({
    common: 'red lighten-1',
    local: 'green',
    external: 'blue',
});

/**
 * データ項目のデータ種別
 */
export const DATA_PROPERTY_DEFINITION_DATA_TYPES = Object.freeze({
    string: '文字列',
    float: '浮動小数',
    integer: '整数',
    datetime: '日付時刻',
    boolean: '真偽値',
    binary: 'バイナリ',
    json: 'JSON'
});

/**
 * プロセス手順の区分
 */
export const PROCESS_OPERATION_OPERATION_TYPES = Object.freeze({
    create: '生成',
    read: '読取',
    update: '更新',
    delete: '削除'
});

/**
 * サービス記録の事実区分
 */
export const SERVICE_RECORD_EVENT_TYPES = Object.freeze({
    create: '生成',
    send: '送信',
    forward: '転送',
    read: '読取',
    store: '保存',
    duplicate: '複製',
    revise: '改変',
    delete: '削除',
    use: '利用',
    receive: '受信',
});

export const CALENDAR_DAYS_OF_WEEK_ORDINAL = Object.freeze({
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
    sunday: 7,
});

export const CALENDAR_DAYS_OF_WEEK = Object.freeze({
    monday: '月',
    tuesday: '火',
    wednesday: '水',
    thursday: '木',
    friday: '金',
    saturday: '土',
    sunday: '日',
});

export const CALENDAR_INTERVAL_TYPES = Object.freeze({
    minute: "分ごと",
    hour: "時間ごと",
    day: "日ごと",
    week: "週間ごと",
    month: "カ月ごと",
    year: "年ごと"
});

export const CALENDAR_WEEKS = Object.freeze([
    {value: 1, label: '1週'},
    {value: 2, label: '2週'},
    {value: 3, label: '3週'},
    {value: 4, label: '4週'},
    {value: 5, label: '最終週'},
]);

export const CONTROLLER_STATUSES = Object.freeze({
    ready: '正常',
    stopped: '停止',
    disconnected: '未接続'
});

export const TERMINAL_COMMUNICATION_PROTOCOLS = Object.freeze({
    amqp: 'AMQP',
    http: 'HTTP'
});

/**
 * IANA が管理するすべてのタイムゾーンID
 */
export const IANA_TZ_IDS = stringLiterals(
    "Africa/Abidjan",
    "Africa/Accra",
    "Africa/Algiers",
    "Africa/Bissau",
    "Africa/Cairo",
    "Africa/Casablanca",
    "Africa/Ceuta",
    "Africa/El_Aaiun",
    "Africa/Johannesburg",
    "Africa/Juba",
    "Africa/Khartoum",
    "Africa/Lagos",
    "Africa/Maputo",
    "Africa/Monrovia",
    "Africa/Nairobi",
    "Africa/Ndjamena",
    "Africa/Sao_Tome",
    "Africa/Tripoli",
    "Africa/Tunis",
    "Africa/Windhoek",
    "America/Adak",
    "America/Anchorage",
    "America/Araguaina",
    "America/Argentina/Buenos_Aires",
    "America/Argentina/Catamarca",
    "America/Argentina/Cordoba",
    "America/Argentina/Jujuy",
    "America/Argentina/La_Rioja",
    "America/Argentina/Mendoza",
    "America/Argentina/Rio_Gallegos",
    "America/Argentina/Salta",
    "America/Argentina/San_Juan",
    "America/Argentina/San_Luis",
    "America/Argentina/Tucuman",
    "America/Argentina/Ushuaia",
    "America/Asuncion",
    "America/Atikokan",
    "America/Bahia",
    "America/Bahia_Banderas",
    "America/Barbados",
    "America/Belem",
    "America/Belize",
    "America/Blanc-Sablon",
    "America/Boa_Vista",
    "America/Bogota",
    "America/Boise",
    "America/Cambridge_Bay",
    "America/Campo_Grande",
    "America/Cancun",
    "America/Caracas",
    "America/Cayenne",
    "America/Chicago",
    "America/Chihuahua",
    "America/Costa_Rica",
    "America/Creston",
    "America/Cuiaba",
    "America/Curacao",
    "America/Danmarkshavn",
    "America/Dawson",
    "America/Dawson_Creek",
    "America/Denver",
    "America/Detroit",
    "America/Edmonton",
    "America/Eirunepe",
    "America/El_Salvador",
    "America/Fort_Nelson",
    "America/Fortaleza",
    "America/Glace_Bay",
    "America/Goose_Bay",
    "America/Grand_Turk",
    "America/Guatemala",
    "America/Guayaquil",
    "America/Guyana",
    "America/Halifax",
    "America/Havana",
    "America/Hermosillo",
    "America/Indiana/Indianapolis",
    "America/Indiana/Knox",
    "America/Indiana/Marengo",
    "America/Indiana/Petersburg",
    "America/Indiana/Tell_City",
    "America/Indiana/Vevay",
    "America/Indiana/Vincennes",
    "America/Indiana/Winamac",
    "America/Inuvik",
    "America/Iqaluit",
    "America/Jamaica",
    "America/Juneau",
    "America/Kentucky/Louisville",
    "America/Kentucky/Monticello",
    "America/La_Paz",
    "America/Lima",
    "America/Los_Angeles",
    "America/Maceio",
    "America/Managua",
    "America/Manaus",
    "America/Martinique",
    "America/Matamoros",
    "America/Mazatlan",
    "America/Menominee",
    "America/Merida",
    "America/Metlakatla",
    "America/Mexico_City",
    "America/Miquelon",
    "America/Moncton",
    "America/Monterrey",
    "America/Montevideo",
    "America/Nassau",
    "America/New_York",
    "America/Nipigon",
    "America/Nome",
    "America/Noronha",
    "America/North_Dakota/Beulah",
    "America/North_Dakota/Center",
    "America/North_Dakota/New_Salem",
    "America/Nuuk",
    "America/Ojinaga",
    "America/Panama",
    "America/Pangnirtung",
    "America/Paramaribo",
    "America/Phoenix",
    "America/Port_of_Spain",
    "America/Port-au-Prince",
    "America/Porto_Velho",
    "America/Puerto_Rico",
    "America/Punta_Arenas",
    "America/Rainy_River",
    "America/Rankin_Inlet",
    "America/Recife",
    "America/Regina",
    "America/Resolute",
    "America/Rio_Branco",
    "America/Santarem",
    "America/Santiago",
    "America/Santo_Domingo",
    "America/Sao_Paulo",
    "America/Scoresbysund",
    "America/Sitka",
    "America/St_Johns",
    "America/Swift_Current",
    "America/Tegucigalpa",
    "America/Thule",
    "America/Thunder_Bay",
    "America/Tijuana",
    "America/Toronto",
    "America/Vancouver",
    "America/Whitehorse",
    "America/Winnipeg",
    "America/Yakutat",
    "America/Yellowknife",
    "Antarctica/Casey",
    "Antarctica/Davis",
    "Antarctica/DumontDUrville",
    "Antarctica/Macquarie",
    "Antarctica/Mawson",
    "Antarctica/Palmer",
    "Antarctica/Rothera",
    "Antarctica/Syowa",
    "Antarctica/Troll",
    "Antarctica/Vostok",
    "Asia/Almaty",
    "Asia/Amman",
    "Asia/Anadyr",
    "Asia/Aqtau",
    "Asia/Aqtobe",
    "Asia/Ashgabat",
    "Asia/Atyrau",
    "Asia/Baghdad",
    "Asia/Baku",
    "Asia/Bangkok",
    "Asia/Barnaul",
    "Asia/Beirut",
    "Asia/Bishkek",
    "Asia/Brunei",
    "Asia/Chita",
    "Asia/Choibalsan",
    "Asia/Colombo",
    "Asia/Damascus",
    "Asia/Dhaka",
    "Asia/Dili",
    "Asia/Dubai",
    "Asia/Dushanbe",
    "Asia/Famagusta",
    "Asia/Gaza",
    "Asia/Hebron",
    "Asia/Ho_Chi_Minh",
    "Asia/Hong_Kong",
    "Asia/Hovd",
    "Asia/Irkutsk",
    "Asia/Jakarta",
    "Asia/Jayapura",
    "Asia/Jerusalem",
    "Asia/Kabul",
    "Asia/Kamchatka",
    "Asia/Karachi",
    "Asia/Kathmandu",
    "Asia/Khandyga",
    "Asia/Kolkata",
    "Asia/Krasnoyarsk",
    "Asia/Kuala_Lumpur",
    "Asia/Kuching",
    "Asia/Macau",
    "Asia/Magadan",
    "Asia/Makassar",
    "Asia/Manila",
    "Asia/Nicosia",
    "Asia/Novokuznetsk",
    "Asia/Novosibirsk",
    "Asia/Omsk",
    "Asia/Oral",
    "Asia/Pontianak",
    "Asia/Pyongyang",
    "Asia/Qatar",
    "Asia/Qostanay",
    "Asia/Qyzylorda",
    "Asia/Riyadh",
    "Asia/Sakhalin",
    "Asia/Samarkand",
    "Asia/Seoul",
    "Asia/Shanghai",
    "Asia/Singapore",
    "Asia/Srednekolymsk",
    "Asia/Taipei",
    "Asia/Tashkent",
    "Asia/Tbilisi",
    "Asia/Tehran",
    "Asia/Thimphu",
    "Asia/Tokyo",
    "Asia/Tomsk",
    "Asia/Ulaanbaatar",
    "Asia/Urumqi",
    "Asia/Ust-Nera",
    "Asia/Vladivostok",
    "Asia/Yakutsk",
    "Asia/Yangon",
    "Asia/Yekaterinburg",
    "Asia/Yerevan",
    "Atlantic/Azores",
    "Atlantic/Bermuda",
    "Atlantic/Canary",
    "Atlantic/Cape_Verde",
    "Atlantic/Faroe",
    "Atlantic/Madeira",
    "Atlantic/Reykjavik",
    "Atlantic/South_Georgia",
    "Atlantic/Stanley",
    "Australia/Adelaide",
    "Australia/Brisbane",
    "Australia/Broken_Hill",
    "Australia/Darwin",
    "Australia/Eucla",
    "Australia/Hobart",
    "Australia/Lindeman",
    "Australia/Lord_Howe",
    "Australia/Melbourne",
    "Australia/Perth",
    "Australia/Sydney",
    "CET",
    "CST6CDT",
    "EET",
    "EST",
    "EST5EDT",
    "Etc/GMT",
    "Etc/GMT-1",
    "Etc/GMT-10",
    "Etc/GMT-11",
    "Etc/GMT-12",
    "Etc/GMT-13",
    "Etc/GMT-14",
    "Etc/GMT-2",
    "Etc/GMT-3",
    "Etc/GMT-4",
    "Etc/GMT-5",
    "Etc/GMT-6",
    "Etc/GMT-7",
    "Etc/GMT-8",
    "Etc/GMT-9",
    "Etc/GMT+1",
    "Etc/GMT+10",
    "Etc/GMT+11",
    "Etc/GMT+12",
    "Etc/GMT+2",
    "Etc/GMT+3",
    "Etc/GMT+4",
    "Etc/GMT+5",
    "Etc/GMT+6",
    "Etc/GMT+7",
    "Etc/GMT+8",
    "Etc/GMT+9",
    "Etc/UTC",
    "Europe/Amsterdam",
    "Europe/Andorra",
    "Europe/Astrakhan",
    "Europe/Athens",
    "Europe/Belgrade",
    "Europe/Berlin",
    "Europe/Brussels",
    "Europe/Bucharest",
    "Europe/Budapest",
    "Europe/Chisinau",
    "Europe/Copenhagen",
    "Europe/Dublin",
    "Europe/Gibraltar",
    "Europe/Helsinki",
    "Europe/Istanbul",
    "Europe/Kaliningrad",
    "Europe/Kiev",
    "Europe/Kirov",
    "Europe/Lisbon",
    "Europe/London",
    "Europe/Luxembourg",
    "Europe/Madrid",
    "Europe/Malta",
    "Europe/Minsk",
    "Europe/Monaco",
    "Europe/Moscow",
    "Europe/Oslo",
    "Europe/Paris",
    "Europe/Prague",
    "Europe/Riga",
    "Europe/Rome",
    "Europe/Samara",
    "Europe/Saratov",
    "Europe/Simferopol",
    "Europe/Sofia",
    "Europe/Stockholm",
    "Europe/Tallinn",
    "Europe/Tirane",
    "Europe/Ulyanovsk",
    "Europe/Uzhgorod",
    "Europe/Vienna",
    "Europe/Vilnius",
    "Europe/Volgograd",
    "Europe/Warsaw",
    "Europe/Zaporozhye",
    "Europe/Zurich",
    "HST",
    "Indian/Chagos",
    "Indian/Christmas",
    "Indian/Cocos",
    "Indian/Kerguelen",
    "Indian/Mahe",
    "Indian/Maldives",
    "Indian/Mauritius",
    "Indian/Reunion",
    "MET",
    "MST",
    "MST7MDT",
    "Pacific/Apia",
    "Pacific/Auckland",
    "Pacific/Bougainville",
    "Pacific/Chatham",
    "Pacific/Chuuk",
    "Pacific/Easter",
    "Pacific/Efate",
    "Pacific/Enderbury",
    "Pacific/Fakaofo",
    "Pacific/Fiji",
    "Pacific/Funafuti",
    "Pacific/Galapagos",
    "Pacific/Gambier",
    "Pacific/Guadalcanal",
    "Pacific/Guam",
    "Pacific/Honolulu",
    "Pacific/Kiritimati",
    "Pacific/Kosrae",
    "Pacific/Kwajalein",
    "Pacific/Majuro",
    "Pacific/Marquesas",
    "Pacific/Nauru",
    "Pacific/Niue",
    "Pacific/Norfolk",
    "Pacific/Noumea",
    "Pacific/Pago_Pago",
    "Pacific/Palau",
    "Pacific/Pitcairn",
    "Pacific/Pohnpei",
    "Pacific/Port_Moresby",
    "Pacific/Rarotonga",
    "Pacific/Tahiti",
    "Pacific/Tarawa",
    "Pacific/Tongatapu",
    "Pacific/Wake",
    "Pacific/Wallis",
    "PST8PDT",
    "WET",
);
